// import React, { useMemo } from 'react';
// import { useApp } from '../../../context/AppContext';
// import StatCard from '../../../components/StatCard/StatCard';
// import PageHeader from '../../../components/PageHeader/PageHeader';
// import './Dashboard.css';

// const AdminDashboard = () => {
//     const { dashboardStats, loading, error } = useApp();
//     console.log("live dashboard data", dashboardStats);

//     // const stats = useMemo(() => {
//     //     if (!dashboardStats || !dashboardStats.data || !dashboardStats.stats) {
//     //         return {
//     //             totalOrders: 0,
//     //             activePumps: 0,
//     //             activeCustomers: 0,
//     //             totalRevenue: 0,
//     //             totalLoyaltyPoints: 0,
//     //         };
//     //     }

//     //     const data = dashboardStats.data[0]; // Assuming single admin data
//     //     const statsData = dashboardStats.stats;

//     //     return {
//     //         totalOrders: statsData.totalBookingsCount || 0,
//     //         activePumps: statsData.activePumpsCount || 0,
//     //         activeCustomers: statsData.activeCustomersCount || 0,
//     //         totalRevenue: data.total_revenue || 0,
//     //         totalLoyaltyPoints: statsData.loyaltyPointsIssued || 0,
//     //     };
//     // }, [dashboardStats]);

//     const stats = useMemo(() => {
//         if (!dashboardStats) {
//             return {
//                 totalOrders: 0,
//                 activePumps: 0,
//                 activeCustomers: 0,
//                 totalRevenue: 0,
//                 totalLoyaltyPoints: 0,
//             };
//         }
//         return {
//             totalOrders: dashboardStats.stats.totalBookingsCount || 0,
//             activePumps: dashboardStats.stats.activePumpsCount || 0,
//             activeCustomers: dashboardStats.stats.activeCustomersCount || 0,
//             totalRevenue: dashboardStats.stats.totalRevenue || 0, // Only if backend gives it
//             totalLoyaltyPoints: dashboardStats.stats.loyaltyPointsIssued || 0,
//         };
//     }, [dashboardStats]);
    

//     if (loading) {
//         return (
//             <div className="admin-dashboard">
//                 <PageHeader title="Admin Dashboard" subtitle="Overview of your diesel order management system" />
//                 <div className="loading-state">
//                     <p>Loading dashboard data...</p>
//                 </div>
//             </div>
//         );
//     }

//     if (error) {
//         return (
//             <div className="admin-dashboard">
//                 <PageHeader title="Admin Dashboard" subtitle="Overview of your diesel order management system" />
//                 <div className="error-state">
//                     <p>Error loading dashboard data: {error}</p>
//                     <button onClick={() => window.location.reload()}>Retry</button>
//                 </div>
//             </div>
//         );
//     }

//     return (
//         <div className="admin-dashboard">
//             <PageHeader title="Admin Dashboard" subtitle="Overview of your diesel order management system" />

//             <div className="dashboard-stats-grid">
//                 <StatCard
//                     title="Total Orders"
//                     value={stats.totalOrders}
//                     subtitle="All time orders"
//                     icon="📦"
//                 />
//                 <StatCard
//                     title="Active Pumps"
//                     value={stats.activePumps}
//                     subtitle="Active pumps"
//                     icon="⛽"
//                 />
//                 <StatCard
//                     title="Active Customers"
//                     value={stats.activeCustomers}
//                     subtitle="Registered customers"
//                     icon="👥"
//                 />
//                 <StatCard
//                     title="Total Revenue"
//                     value={`₹${stats.totalRevenue.toLocaleString('en-IN')}`}
//                     subtitle="From completed orders"
//                     icon="💰"
//                 />
//                 <StatCard
//                     title="Loyalty Points Issued"
//                     value={stats.totalLoyaltyPoints.toLocaleString('en-IN')}
//                     subtitle="Total points in system"
//                     icon="⭐"
//                 />
//                          <div className="dashboard-charts">
//                 <div className="chart-card">
//                     <h3 className="chart-title">Orders by Status</h3>
//                     <div className="chart-content">
//                         <div className="status-bar">
//                             <div className="status-item">
//                                 <span className="status-label">Pending</span>
//                                 <div className="status-bar-container">
//                                     <div
//                                         className="status-bar-fill status-pending"
//                                         style={{ width: `${(stats.pendingOrders / stats.totalCount) * 100}%` }}
//                                     />
//                                 </div>
//                                 <span className="status-value">{stats.pendingOrders}</span>
//                             </div>
//                             <div className="status-item">
//                                 <span className="status-label">Accepted</span>
//                                 <div className="status-bar-container">
//                                     <div
//                                         className="status-bar-fill status-accepted"
//                                         style={{ width: `${(stats.acceptedOrders / stats.totalOrders) * 100}%` }}
//                                     />
//                                 </div>
//                                 <span className="status-value">{stats.acceptedOrders}</span>
//                             </div>
//                             <div className="status-item">
//                                 <span className="status-label">Completed</span>
//                                 <div className="status-bar-container">
//                                     <div
//                                         className="status-bar-fill status-completed"
//                                         style={{ width: `${(stats.completedOrders / stats.totalOrders) * 100}%` }}
//                                     />
//                                 </div>
//                                 <span className="status-value">{stats.completedOrders}</span>
//                             </div>
//                             <div className="status-item">
//                                 <span className="status-label">Cancelled</span>
//                                 <div className="status-bar-container">
//                                     <div
//                                         className="status-bar-fill status-cancelled"
//                                         style={{ width: `${(stats.cancelledOrders / stats.totalOrders) * 100}%` }}
//                                     />
//                                 </div>
//                                 <span className="status-value">{stats.cancelledOrders}</span>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//             </div>


//         </div>
//     );
// };

// export default AdminDashboard;



// src/pages/AdminDashboard/AdminDashboard.jsx
import React, { useMemo } from "react";
import { useApp } from "../../../context/AppContext";
import StatCard from "../../../components/StatCard/StatCard";
import PageHeader from "../../../components/PageHeader/PageHeader";
import "./Dashboard.css";

/**
 * AdminDashboard
 * - maps dashboardStats returned from backend to UI-friendly fields
 * - backend shape expected (example):
 *   {
 *     data: [ { _id: "...", name: "...", total_revenue: 1802.39, ... } ],
 *     stats: {
 *       acceptedOrders: 2,
 *       activeCustomersCount: 10,
 *       activePumpsCount: 4,
 *       cancelledOrders: 0,
 *       completedOrders: 2,
 *       loyaltyPointsIssued: 80,
 *       pendingOrders: 11,
 *       totalBookingsCount: 15,
 *       totalRevenue: 1802.39
 *     }
 *   }
 *
 * NOTE: if you want to visually debug the backend response you logged earlier,
 * there's a dev screenshot available at:
 * "/mnt/data/25b923aa-d4e8-4fd0-ba31-452d6f66af99.png"
 * (useful only for local debugging — remove in production)
 */

const AdminDashboard = () => {
  const { dashboardStats, loading, error } = useApp();

  // optional debug screenshot path (from your session)
  const debugScreenshot = "/mnt/data/25b923aa-d4e8-4fd0-ba31-452d6f66af99.png";

  const stats = useMemo(() => {
    // default shape to avoid crashes
    const empty = {
      totalOrders: 0,
      activePumps: 0,
      activeCustomers: 0,
      totalRevenue: 0,
      totalLoyaltyPoints: 0,
      acceptedOrders: 0,
      cancelledOrders: 0,
      completedOrders: 0,
      pendingOrders: 0,
      totalCount: 0,
    };

    if (!dashboardStats) return empty;

    // stats counts live in dashboardStats.stats
    const statsData = dashboardStats.stats || {};

    // additional numeric values (like total_revenue) may live in data[0]
    const adminData =
      Array.isArray(dashboardStats.data) && dashboardStats.data.length > 0
        ? dashboardStats.data[0]
        : {};

    // pick revenue from adminData.total_revenue first, fallback to statsData.totalRevenue
    const totalRevenue = Number(adminData.total_revenue ?? statsData.totalRevenue ?? 0) || 0;

    // derive totals for chart percentages; prefer totalBookingsCount if provided
    const totalCount = Number(statsData.totalBookingsCount ?? 0) || 0;

    return {
      totalOrders: Number(statsData.totalBookingsCount ?? 0),
      activePumps: Number(statsData.activePumpsCount ?? 0),
      activeCustomers: Number(statsData.activeCustomersCount ?? 0),
      totalRevenue,
      totalLoyaltyPoints: Number(statsData.loyaltyPointsIssued ?? 0),

      // Chart breakdown
      acceptedOrders: Number(statsData.acceptedOrders ?? 0),
      cancelledOrders: Number(statsData.cancelledOrders ?? 0),
      completedOrders: Number(statsData.completedOrders ?? 0),
      pendingOrders: Number(statsData.pendingOrders ?? 0),
      totalCount,
    };
  }, [dashboardStats]);

  // safe percentage helper
  const percent = (part, total) => {
    const t = Number(total) || 0;
    if (!t) return "0%";
    const p = (Number(part) || 0) / t * 100;
    // clamp and format to 1 decimal
    const clamped = Math.max(0, Math.min(100, p));
    return `${clamped.toFixed(1)}%`;
  };

  if (loading) {
    return (
      <div className="admin-dashboard">
        <PageHeader title="Admin Dashboard" subtitle="Overview of your diesel order management system" />
        <div className="loading-state">
          <p>Loading dashboard data...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="admin-dashboard">
        <PageHeader title="Admin Dashboard" subtitle="Overview of your diesel order management system" />
        <div className="error-state">
          <p>Error loading dashboard data: {String(error)}</p>
          <button onClick={() => window.location.reload()}>Retry</button>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-dashboard">
      <PageHeader title="Admin Dashboard" subtitle="Overview of your diesel order management system" />

      <div className="dashboard-stats-grid">
        <StatCard title="Total Orders" value={stats.totalOrders} subtitle="All time orders" icon="📦" />
        <StatCard title="Active Pumps" value={stats.activePumps} subtitle="Active pumps" icon="⛽" />
        <StatCard title="Active Customers" value={stats.activeCustomers} subtitle="Registered customers" icon="👥" />
        <StatCard
          title="Total Revenue"
          value={`₹${Number(stats.totalRevenue || 0).toLocaleString("en-IN")}`}
          subtitle="From completed orders"
          icon="💰"
        />
        <StatCard
          title="Loyalty Points Issued"
          value={Number(stats.totalLoyaltyPoints || 0).toLocaleString("en-IN")}
          subtitle="Total points in system"
          icon="⭐"
        />
      </div>

      <div className="dashboard-charts">
        <div className="chart-card">
          <h3 className="chart-title">Orders by Status</h3>
          <div className="chart-content">
            <div className="status-bar">
              <div className="status-item">
                <span className="status-label">Pending</span>
                <div className="status-bar-container">
                  <div
                    className="status-bar-fill status-pending"
                    style={{ width: percent(stats.pendingOrders, stats.totalCount) }}
                  />
                </div>
                <span className="status-value">{stats.pendingOrders}</span>
              </div>

              <div className="status-item">
                <span className="status-label">Accepted</span>
                <div className="status-bar-container">
                  <div
                    className="status-bar-fill status-accepted"
                    style={{ width: percent(stats.acceptedOrders, Math.max(stats.totalCount, 1)) }}
                  />
                </div>
                <span className="status-value">{stats.acceptedOrders}</span>
              </div>

              <div className="status-item">
                <span className="status-label">Completed</span>
                <div className="status-bar-container">
                  <div
                    className="status-bar-fill status-completed"
                    style={{ width: percent(stats.completedOrders, Math.max(stats.totalCount, 1)) }}
                  />
                </div>
                <span className="status-value">{stats.completedOrders}</span>
              </div>

              <div className="status-item">
                <span className="status-label">Cancelled</span>
                <div className="status-bar-container">
                  <div
                    className="status-bar-fill status-cancelled"
                    style={{ width: percent(stats.cancelledOrders, Math.max(stats.totalCount, 1)) }}
                  />
                </div>
                <span className="status-value">{stats.cancelledOrders}</span>
              </div>
            </div>
          </div>
        </div>

        {/* Dev debug image — remove in production */}
        {/* <div style={{ marginTop: 16 }}>
          <h4>Backend snapshot (debug)</h4>
          <img src={debugScreenshot} alt="dashboard backend snapshot" style={{ maxWidth: "100%" }} />
        </div> */}
      </div>
    </div>
  );
};

export default AdminDashboard;
